/* assets/infinite-scroll.js — Prestige v11 <product-list> infinite scroll (Emery)
 *
 * Changes vs previous version:
 * - Fetches only the collection section via the Section Rendering API
 *   (?section_id=…) instead of the whole page (header, footer, scripts…).
 * - Re-arms itself whenever filters/sort re-render the grid or change the URL,
 *   so it never keeps loading the unfiltered "page 2" into a filtered grid.
 * - If a request fails, the normal pagination comes back instead of a dead end.
 * - No console logging in production.
 * Keeps window.__pagesLoaded and window.__loadNextCollectionPage for the
 * scroll-restore script in layout/theme.liquid.
 */
(function () {
  if (window.__INF_SCROLL_RUNNING__) return;
  window.__INF_SCROLL_RUNNING__ = true;
  if (!('IntersectionObserver' in window)) return;

  var SECTION_SEL = '.shopify-section--main-collection';
  var GRID_SEL = 'product-list.product-list';
  var NEXT_SEL = 'a[rel="next"], .pagination__next a, a.pagination__next, .pagination a.next';
  var PAGINATION_SEL = '.pagination, nav.pagination';

  var grid = null;
  var nextURL = null;
  var io = null;
  var sentinel = null;
  var loading = false;
  var armedFor = null;

  function getSection() {
    return document.querySelector(SECTION_SEL);
  }

  // Filters/sort live in the query string; "page" does not count as a change.
  function filterKey() {
    var p = new URLSearchParams(location.search);
    p.delete('page');
    p.delete('section_id');
    return location.pathname + '?' + p.toString();
  }

  function cleanHref(href) {
    if (!href) return null;
    var u = new URL(href, location.href);
    u.searchParams.delete('section_id');
    return u.pathname + u.search;
  }

  function sectionUrl(href, sectionId) {
    var u = new URL(href, location.href);
    if (sectionId) u.searchParams.set('section_id', sectionId);
    return u.toString();
  }

  function showPagination(section) {
    var p = section && section.querySelector(PAGINATION_SEL);
    if (p) p.style.display = '';
  }

  function arm() {
    if (io) { io.disconnect(); io = null; }
    if (sentinel && sentinel.parentNode) sentinel.parentNode.removeChild(sentinel);
    sentinel = null;
    nextURL = null;
    window.__pagesLoaded = 1;
    armedFor = filterKey();

    var section = getSection();
    grid = section ? section.querySelector(GRID_SEL) : null;
    if (!grid) return;

    var a = section.querySelector(NEXT_SEL);
    if (!a) return; // single page of results

    nextURL = cleanHref(a.getAttribute('href'));
    var pagination = a.closest(PAGINATION_SEL);
    if (pagination) pagination.style.display = 'none';

    sentinel = document.createElement('div');
    sentinel.setAttribute('aria-hidden', 'true');
    sentinel.style.cssText = 'height:1px;width:100%;';
    grid.insertAdjacentElement('afterend', sentinel);

    io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) { loadNext(); break; }
      }
    }, { rootMargin: '800px 0px 800px 0px' });
    io.observe(sentinel);
  }

  async function loadNext() {
    if (!nextURL || loading || !grid) return false;
    loading = true;

    var targetGrid = grid;
    var section = getSection();
    var sectionId = section ? (section.id || '').replace('shopify-section-', '') : '';

    try {
      var res = await fetch(sectionUrl(nextURL, sectionId), { credentials: 'same-origin' });
      if (!res.ok) throw new Error('HTTP ' + res.status);
      var doc = new DOMParser().parseFromString(await res.text(), 'text/html');

      // Filters changed while we were fetching: drop this page, arm() already ran.
      if (targetGrid !== grid || !targetGrid.isConnected) return false;

     var nextGrid = doc.querySelector(GRID_SEL);
var items = nextGrid ? Array.from(nextGrid.children) : [];
var addedProducts = 0;

for (var i = 0; i < items.length; i++) {
  var item = items[i];

  if (
    !item.matches('product-card') &&
    !item.matches('.product-list__promo')
  ) {
    continue;
  }

  item.removeAttribute('reveal-on-scroll');
  item.classList.add('is-revealed');

  if (item.matches('product-card')) {
    addedProducts++;
  }

  targetGrid.appendChild(item);
}

      var n = doc.querySelector(NEXT_SEL);
      nextURL = n ? cleanHref(n.getAttribute('href')) : null;

  if (addedProducts) {
  window.__pagesLoaded = (window.__pagesLoaded || 1) + 1;
  try {
    document.dispatchEvent(
      new CustomEvent('collection:appended', {
        detail: { added: addedProducts }
      })
    );
  } catch (e) {}
}

      if (!nextURL && io) io.disconnect();
      return addedProducts > 0;
    } catch (err) {
      if (io) io.disconnect();
      showPagination(getSection()); // never leave shoppers at a dead end
      return false;
    } finally {
      loading = false;
    }
  }

  window.__loadNextCollectionPage = loadNext;

  if (!getSection()) return;
  arm();

  // Re-arm when Prestige re-renders the grid for filters/sort, or the URL's filters change.
  var root = document.getElementById('main') || document.body;
  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      var section = getSection();
      var g = section ? section.querySelector(GRID_SEL) : null;
      if (g !== grid || filterKey() !== armedFor) arm();
    });
  }).observe(root, { childList: true, subtree: true });
})();